"use client";

import { useEffect, useState } from "react";
import Script from "next/script";
import { usePathname } from "next/navigation";

const CONSENT_KEY = "hill_medical_consent_v2";

export default function FacebookPixel() {
  const pathname = usePathname();
  const [hasConsent, setHasConsent] = useState(false);

  useEffect(() => {
    const checkConsent = () => {
      const saved = localStorage.getItem(CONSENT_KEY);
      if (saved) {
        try {
          const parsed = JSON.parse(saved);
          setHasConsent(parsed.ad_storage === "granted");
        } catch (e) {
          setHasConsent(false);
        }
      } else {
        setHasConsent(false);
      }
    };

    checkConsent();
    window.addEventListener("storage", checkConsent);
    window.addEventListener("analytics-consent-updated", checkConsent as EventListener);

    return () => {
      window.removeEventListener("storage", checkConsent);
      window.removeEventListener("analytics-consent-updated", checkConsent as EventListener);
    };
  }, []);

  if (!hasConsent || pathname.startsWith("/admin")) {
    return null;
  }

  return (
    <Script id="fb-pixel" strategy="lazyOnload">
      {`
        !function(f,b,e,v,n,t,s)
        {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
        n.callMethod.apply(n,arguments):n.queue.push(arguments)};
        if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
        n.queue=[];t=b.createElement(e);t.async=!0;
        t.src=v;s=b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t,s)}(window, document,'script',
        'https://connect.facebook.net/en_US/fbevents.js');
        fbq('init', '1110760790528718');
        fbq('track', 'PageView');
      `}
    </Script>
  );
}
